<img
  class="picture {{ size() }} bg-{{ background() }}"
  [class.no-rounding]="roundedBorder() === false"
  [src]="(image$ | async) || userPlaceholder"
  [alt]="gid()" />
